import React from 'react';
import { Modal, Box, Grid } from '@mui/material';

import { IoCloseCircleOutline } from 'react-icons/io5';

const NotConnectedModal = ({
  open,
  setOpen,
  modalContent,
  width,
  modalTitle,
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width ? width : '30%',
    border: false,
    boxShadow: 24,
    borderRadius: '0.5em',
  };

  return (
    <Modal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={open}
      onClose={() => setOpen(false)}
      width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
      cent
    >
      <Box sx={style} className="ModalBG p-3 d-flex flex-column">
        <Grid
          container
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          lg={12}
          xs={12}
          md={12}
          className="GradiantButton rounded-top "
        >
          <Grid
            container
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className="rounded-top"
          >
            <h4> {modalTitle}</h4>

            <IoCloseCircleOutline
              onClick={() => setOpen(false)}
              style={{ cursor: 'pointer', color: '#FFF' }}
              size={30}
              className="mb-2"
            />
          </Grid>
        </Grid>
        <div className="text-center text-white">{modalContent}</div>
      </Box>
    </Modal>
  );
};

export default NotConnectedModal;
